// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SyncButton_syncButton__yOpjW {
  background: #4caf50;
  border: none;
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.SyncButton_syncButton__yOpjW:hover:not(:disabled) {
  background: #45a049;
}
.SyncButton_syncButton__yOpjW:disabled {
  background: #ccc;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/NotificationCenter/SyncButton.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,gBAAA;EACA,mBAAA;AAAJ","sourcesContent":[".syncButton {\n  background: #4caf50;\n  border: none;\n  color: white;\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  &:hover:not(:disabled) {\n    background: #45a049;\n  }\n\n  &:disabled {\n    background: #ccc;\n    cursor: not-allowed;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"syncButton": `SyncButton_syncButton__yOpjW`
};
export default ___CSS_LOADER_EXPORT___;
